<div class="tab-content">
  <div
    *ngFor="let education of educations; trackBy: trackElement"
    class="item"
  >

    <h5>
      {{ (education?.degree + ', ' + education?.majorCourse) | mojoHighlight: keywords }}
    </h5>

    <dl class="row">
      <dt class="col-md-2">School:</dt>
      <dd class="col-md-10">
        {{ education?.schoolName | mojoHighlight: keywords }}</dd>

      <dt
        *ngIf="!!education?.startDate && education?.endDate"
        class="col-md-2"
      >Dates:</dt>
      <dd
        *ngIf="!!education?.startDate && education?.endDate"
        class="col-md-10"
      >{{ education?.startDate | daysPassed: true }}
        - {{ education?.endDate | daysPassed: true }}</dd>
    </dl>

  </div>
</div>
